/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:02:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-01 16:22:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/Summary/index.tsx
 */
import React from 'react';
import StatusTag from '../StatusTag';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
interface IProps {
  name: string;
  status: string;
  summaryContent?: string[];
}

const Summary = ({ name, status, summaryContent }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return name || (summaryContent && summaryContent.length) ? (
    <div>
      <h3 className={css.summaryTitle}>
        <span>{name}</span> <StatusTag status={status} />
      </h3>
      <div className={css.summaryContent}>
        {summaryContent.map((content, index) => (
          <p key={index}>
            <span className={css.round}>•</span> {content}
          </p>
        ))}
      </div>
    </div>
  ) : (
    <div>{getI18n('salesChannelVoucher.summary.noinformationenteredyet')}</div>
  );
};

export default Summary;
